import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
const appElement = document.getElementById('maincontent');
Modal.setAppElement(appElement ? appElement : document.getElementsByTagName('body')[0]);
const Drawers = (props) => {
    const { t } = useTranslation();
    const closeButton = () => {
        return (React.createElement("button", { type: "button", "aria-label": t('button.close'), className: classNames('modal__close', props.closeInvertedSm && 'modal__close--inverted-sm', props.isSticky && 'is__sticky'), onClick: (e) => {
                e.stopPropagation();
                props === null || props === void 0 ? void 0 : props.onRequestClose(e);
            } }));
    };
    useEffect(() => {
        window.gbotNormalizer();
    }, [props.children]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, Object.assign({ closeTimeoutMS: 600 }, props, { overlayClassName: classNames('overlay-modal drawers-overlay-modal', props.overlayClassName, props.hasBackdrop ? 'backdrop--bg-transparent' : ''), className: classNames('drawers', props.className) }),
            !props.buttonInHeader && closeButton(),
            props.buttonInHeader && closeButton(),
            props.subjsx && props.subjsx(),
            props.children),
        React.createElement("div", { className: "googlebot-content-view", hidden: true }, props.children)));
};
export default Drawers;
